import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import IconButtonLink from '@dashboard/components/mui-atoms/IconButtonLink';
import WpSessionDropdown from '@dashboard/components/SessionDropdown';
import { ArrowBack } from '@mui/icons-material';
import { AppBar, Divider, Stack, Toolbar } from '@mui/material';

type Props = {
  backHref: string;
  leftChildren?: JsxNode;
  rightChildren: JsxNode;
};
export default function FormPageNavBar({ backHref, leftChildren, rightChildren }: Props) {
  const { state } = useLocation();
  const backLinkHref = useMemo(() => {
    if (state && typeof state.backLinkHref === 'string') {
      return state.backLinkHref;
    }
    return backHref;
  }, [backHref, state]);

  return (
    <AppBar color="primary" position="sticky" sx={{ zIndex: 'appBar' }}>
      <Toolbar
        component={Stack}
        disableGutters
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2 }}
      >
        <Stack spacing={2} direction="row" alignItems="center">
          <IconButtonLink href={backLinkHref} color="inherit">
            <ArrowBack fontSize="small" />
          </IconButtonLink>

          <Divider flexItem orientation="vertical" />

          {leftChildren}
        </Stack>

        <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between">
          {rightChildren}

          <Divider flexItem orientation="vertical" />

          <WpSessionDropdown />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
